import React from 'react'
import PropTypes from 'prop-types'

export function Logo({ width = 102, style = {} }) {
  return (
    <svg
      width={width}
      style={style}
      viewBox="0 0 102 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M76.5554 0C70.9027 0 64.7409 2.91069 58.228 8.64388C55.1384 11.3605 52.47 14.2712 50.4688 16.5998C50.4688 16.5998 50.4688 16.5998 50.4863 16.6174V16.5998C50.4863 16.5998 53.6462 20.0573 57.1396 23.7618C59.018 21.5215 61.7215 18.4697 64.8287 15.7177C70.6219 10.6196 74.3962 9.54355 76.5554 9.54355C84.6834 9.54355 91.2841 16.0176 91.2841 23.9735C91.2841 31.8765 84.6658 38.3506 76.5554 38.4035C76.1868 38.4035 75.7128 38.3506 75.1159 38.2271C77.4859 39.2503 80.0313 39.9912 82.4539 39.9912C97.3405 39.9912 100.255 30.2359 100.448 29.5303C100.887 27.7486 101.115 25.8787 101.115 23.9559C101.115 10.7607 90.0903 0 76.5554 0Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M24.5594 47.9824C30.2121 47.9824 36.3739 45.0717 42.8868 39.3386C45.9765 36.6219 48.6448 33.7112 50.6461 31.3827C50.6461 31.3827 50.6461 31.3827 50.6285 31.365V31.3827C50.6285 31.3827 47.4686 27.9251 43.9752 24.2206C42.0968 26.4609 39.3933 29.5128 36.2861 32.2647C30.493 37.3628 26.7187 38.4389 24.5594 38.4389C16.4314 38.4389 9.83078 31.9648 9.83078 24.0089C9.83078 16.1059 16.449 9.63184 24.5594 9.57892C24.9281 9.57892 25.402 9.63184 25.9989 9.75533C23.629 8.73218 21.0835 7.99127 18.6609 7.99127C3.77432 7.99127 0.860194 17.7465 0.667089 18.4521C0.228215 20.2338 0 22.1037 0 24.0265C0 37.2217 11.0245 47.9824 24.5594 47.9824Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M82.421 39.7798C74.8021 39.5858 66.8848 33.5527 65.2698 32.0532C61.0917 28.1723 51.454 17.6762 50.6991 16.8471C43.642 8.90882 34.0746 0.0179749 24.5598 0.0179749H24.5422H24.5247C12.9735 0.0708966 3.24806 7.93859 0.66748 18.4347C0.860585 17.7467 4.67001 7.79747 18.6438 8.15028C26.2626 8.34432 34.215 14.4656 35.8476 15.965C40.0257 19.846 49.6634 30.3421 50.4183 31.1712C57.4754 39.1095 67.0428 48.0003 76.5576 48.0003H76.5752H76.5927C88.1439 47.9474 97.8693 40.0797 100.45 29.5836C100.239 30.2539 96.4123 40.115 82.421 39.7798Z"
        fill="#29ABE2"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="63.7709"
          y1="3.16377"
          x2="97.3304"
          y2="37.747"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#F15A24" />
          <stop offset="0.6841" stopColor="#FBB03B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="37.3439"
          y1="44.8187"
          x2="3.78441"
          y2="10.2354"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#ED1E79" />
          <stop offset="0.8929" stopColor="#522785" />
        </linearGradient>
      </defs>
    </svg>
  )
}

Logo.propTypes = {
  width: PropTypes.number,
  style: PropTypes.object,
}
